import app from '../../angular_app.es6';
import remoteFiles from '../../../approach-react/common/remote_files';
import baseHandler from './package_details/base_handler.es6';

app.controller('DetailsPackageMCController', [
  '$scope', 'Notification', '$timeout', '$http', '$element', '$interval', '$rootScope',
  ($scope, Notification, $timeout, $http, $element, $interval, $rootScope) => {
    baseHandler($scope, Notification, $timeout, $http, $element, $interval, $rootScope);

    $scope.findProperAttributeName = (metric, item, index) => {
      const default_metric = metric.default_metric;
      const translations = $scope.options.attribute_translations_by_dm_kind;
      const translationKeyPart = translations.name[default_metric.name];
      const translationsKey = `${translationKeyPart}_${index + 1}`;

      return translations[default_metric.name][translationsKey];
    };

    $scope.questionImages = remoteFiles.express.packageMcQuestions;

    $scope.isLeftRight = (metric) => {
      return metric.default_metric.name === "package_mc_attributes";
    };

    $scope.leftRightHasError = (item) => {
      const parts = (item.question || '').split(' || ');
      return !item.abstract && (parts.length !== 2 || parts[0].trim() === '' || parts[1].trim() === '');
    };
  }
]);
